import { render } from "./RequisitionCreate.vue?vue&type=template&id=00ce3186&scoped=true"
import script from "./RequisitionCreate.vue?vue&type=script&lang=js"
export * from "./RequisitionCreate.vue?vue&type=script&lang=js"

import "./RequisitionCreate.vue?vue&type=style&index=0&id=00ce3186&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ce3186"]])

export default __exports__